import React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { CallbackComponent } from "redux-oidc";
import { push } from "react-router-redux";
import { getUserManager } from "../util/userManager";
//import { getUserCall } from '../actions/performAction';
import { setToken } from "../util/sessionUtil";
import { userActions } from '../actions';

class CallbackPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      oidcData: null
    }
  }

  getSuccessToken = (e) => {
    //console.log("eId token",e.id_token);
    setToken(e.id_token);
    this.props.dispatch(userActions.login("/getLoggedInUser", "USER_DATA"));

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.oidcData) {
      this.setState({ oidcData: nextProps.oidcData });
    }
  }

  render() {
    console.log('callBackPageProps:',this.props)
    return (
      <CallbackComponent
        userManager={getUserManager()}
        successCallback={this.getSuccessToken}
        errorCallback={error => {
          this.props.dispatch(push("/"));
          console.error("ERROR : " + error);
        }}
      >
        <div style={styles.root}>
          <h3>Redirecting...</h3>
        </div>
      </CallbackComponent>
    );
  }
}
const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    flexShrink: 1,
    paddingTop: '10rem'
  }
};
const mapStateToProps = (state) => {
  return {
    oidcData: state.oidc.user
  }
}
export default withRouter(connect(mapStateToProps)(CallbackPage));
